export interface Reference {
  id: number;
  reference: number;
  link: string;
  actions: number[];
}

export const referencesRows: Reference[] = [
  {
    id: 1,
    reference: 1,
    link: '<a href="https://www.niap-ccevs.org/Documents_and_Guidance/ccevs/scheme-pub-3.pdf" target="_self">CCEVS Scheme: Guidance to Validators</a>',
    actions: [13, 43],
  },
  {
    id: 2,
    reference: 2,
    link: '<a href="https://www.niap-ccevs.org/MMO/GD/CICO.pdf" target="_self">Check-In Check-Out (CICO) Guidance</a>',
    actions: [13, 15, 19, 43],
  },
  {
    id: 3,
    reference: 3,
    link: '<a href="https://www.niap-ccevs.org/Accounts/File/DocView.cfm?Medial=/Training/Live_Material/&Item=6270" target="_self">Guidance for Performing NIAP Validator Activities</a>',
    actions: [13, 15, 38, 40, 41, 43],
  },
  {
    id: 4,
    reference: 4,
    link: '<a href="https://www.niap-ccevs.org/Documents_and_Guidance/ccevs/Entropy%20Submission%20and%20Review%20Process.pdf" target="_self">Entropy Submission and Review Process</a>',
    actions: [13, 15],
  },
  {
    id: 5,
    reference: 5,
    link: '<a href="https://www.niap-ccevs.org/Accounts/File/DocView.cfm?Medial=/Training/Live_Material/&Item=6269" target="_self">Entropy Assessment Worksheet</a>',
    actions: [13, 15],
  },
  {
    id: 6,
    reference: 6,
    link: '<a href="https://www.niap-ccevs.org/Documents_and_Guidance/labgrams/labgram.cfm?id=80" target="_self">Entropy Assessment Reports That Do Not Require IAD Review</a>',
    actions: [13, 15],
  },
  {
    id: 7,
    reference: 7,
    link: '<a href="https://www.niap-ccevs.org/Documents_and_Guidance/ccevs/Entropy%20Documentation%20and%20Assessment%20Clarification.pdf" target="_self">Entropy Documentation and Assessment Clarification</a>',
    actions: [13, 15],
  },
  {
    id: 8,
    reference: 8,
    link: '<a href="https://www.niap-ccevs.org/Documents_and_Guidance/ccevs/policy-ltr-1-update2.pdf" target="_self">Appropriateness of Language Guidance </a>',
    actions: [13, 41],
  },
  {
    id: 9,
    reference: 9,
    link: '<a href="https://www.niap-ccevs.org/Documents_and_Guidance/policy-ltr-5-add2.pdf" target="_self">NIST Evaluation CAVP Mapping Guidance </a>',
    actions: [13, 41],
  },
  {
    id: 10,
    reference: 10,
    link: '<a href="https://www.NSA.gov/Resources/Commercial-Solutions-for-Classified-Program/components-list/" target="_self">CSfC Selection Documents </a>',
    actions: [13, 41],
  },
  {
    id: 11,
    reference: 11,
    link: '<a href="https://www.niap-ccevs.org/Documents_and_Guidance/ccevs/Assurance%20Activity%20Reporting%20Guidance.pdf" target="_self">Assurance Activity Reporting Guidance</a>',
    actions: [41],
  },
  {
    id: 12,
    reference: 12,
    link: '<a href="https://www.niap-ccevs.org/Accounts/File/DocView.cfm?Medial=/Training/Live_Material/&Item=6266" target="_self">CCTL Proficiency Questionnaire</a>',
    actions: [43],
  },
  {
    id: 13,
    reference: 13,
    link: '<a href="https://www.niap-ccevs.org/Accounts/File/DocView.cfm?Medial=/Training/Live_Material/&Item=6268" target="_self">ECR Comment Facility Guide for Validators</a>',
    actions: [13, 38, 40, 41],
  },
  {
    id: 14,
    reference: 14,
    link: '<a href="https://www.niap-ccevs.org/Accounts/File/DocView.cfm?Medial=/Training/Live_Material/&Item=6267" target="_self">Common Criteria Overview</a>',
    actions: [],
  },
  {
    id: 15,
    reference: 15,
    link: '<a href="https://www.niap-ccevs.org/Documents_and_Guidance/policy.cfm" target="_self">NIAP Policies</a>',
    actions: [],
  },
  {
    id: 16,
    reference: 16,
    link: '<a href="https://www.niap-ccevs.org/Documents_and_Guidance/guidance_docs.cfm" target="_self">NIAP Publications</a>',
    actions: [],
  },
  {
    id: 17,
    reference: 17,
    link: '<a href="https://www.niap-ccevs.org/Accounts/File/DocView.cfm?Medial=/Training/Live_Material/&Item=6388" target="_self">TRRT Mini Process Description</a>',
    actions: [25, 40],
  },
  {
    id: 18,
    reference: 18,
    link: '<a href="https://www.niap-ccevs.org/Accounts/File/DocView.cfm?Medial=/Training/Live_Material/&Item=6387" target="_self">ECR Tool Mini Process Description</a>',
    actions: [40, 41],
  },
];
